var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-documents-add-doc-type float-right" },
    [
      _c(
        "button",
        {
          staticClass: "btn btn--orange",
          attrs: { id: "project-documents-documents-add", type: "button" },
          on: { click: _vm.openModal },
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("action.addFolder")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "HKLModal",
        {
          ref: "docTypeModal",
          staticClass: "add-doc-type-modal",
          attrs: { okBtnAction: "confirm" },
          on: {
            onOkClick: function () {
              return _vm.addFolders()
            },
            onCloseClick: function () {
              return _vm.closeModal()
            },
          },
        },
        [
          _c("div", [
            _c("p", { staticClass: "confirm-header" }, [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("action.addFolders")) + "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("table", [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { colspan: "2" } }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(_vm.$t("project.docs.projectFolder")) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.folderData, function (folderItem, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(folderItem.folderName))]),
                    _vm._v(" "),
                    _c("td", [
                      _c("div", { staticClass: "flex items-center gap-1" }, [
                        _c("i", {
                          staticClass: "fa fa-minus cursor-pointer",
                          class: { "disabled-minus": folderItem.amount === 0 },
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function () {
                              return (
                                folderItem.amount > 0 &&
                                _vm.updateAmountByIndex(index, -1)
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: folderItem.amount,
                              expression: "folderItem.amount",
                            },
                          ],
                          staticClass: "doctype-amount",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: folderItem.amount },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                folderItem,
                                "amount",
                                $event.target.value
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "fa fa-plus cursor-pointer",
                          attrs: { "aria-hidden": "true" },
                          on: {
                            click: function () {
                              return _vm.updateAmountByIndex(index, 1)
                            },
                          },
                        }),
                      ]),
                    ]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }